import {
  collection,
  doc,
  getDocs,
  updateDoc,
  serverTimestamp,
} from 'firebase/firestore';
import { db } from '../config';
import { featureCategories } from '../../data/filterOptions';

export const setCategoryFeatures = async () => {
  try {
    console.log('Starting feature category migration...');
    const featuresCollection = collection(db, 'features');
    const snapshot = await getDocs(featuresCollection);
    
    let updatedCount = 0;
    const updates = [];

    // Create map of features to their categories
    const categoryMap = {};
    Object.entries(featureCategories).forEach(([category, data]) => {
      data.features.forEach(featureId => {
        categoryMap[featureId] = category;
      });
    });

    snapshot.forEach((docSnap) => {
      const featureId = docSnap.id;
      const data = docSnap.data();
      
      // If feature doesn't have a category but exists in our category mapping
      if (!data.category && categoryMap[featureId]) {
        updates.push(
          updateDoc(doc(featuresCollection, featureId), {
            category: categoryMap[featureId],
            updatedAt: serverTimestamp()
          })
        );
        updatedCount++;
      }
    });

    await Promise.all(updates);
    console.log(`Updated ${updatedCount} features with categories`);
    
    return { success: true, data: { updated: updatedCount } };
  } catch (error) {
    console.error('Error setting feature categories:', error);
    return { success: false, error: error.message };
  }
};
